import { observer } from "mobx-react-lite"
import { useEffect } from "react"
import { Outlet } from "react-router-dom"
import stockManagementStore from "features/iot/stock-management/stores/stock-management-store"
import sensorBatchStore from "features/iot/sensor-batch/stores/sensor-batch-store"
import LowSpinner from "components/common/low-spinner"

const StockManagementLoader: React.FC = observer(() => {
    const { sensorBatches, loadAllSensorBatches } = sensorBatchStore
    const { loadAllSensors, allSensorsStockManagement } = stockManagementStore

    // Load sensor batches if not already loaded
    useEffect(() => {
        if (!sensorBatches.length) {
            loadAllSensorBatches()
        }
    }, [sensorBatches.length])

    // Load all sensors if not already loaded
    useEffect(() => {
        if (!allSensorsStockManagement.length) {
            loadAllSensors()
        }
    }, [allSensorsStockManagement.length])

    if (!sensorBatches.length) {
        return <LowSpinner id={"sensorBatch.loading"} />
    } else if (!allSensorsStockManagement.length) {
        return <LowSpinner id={"stockAllocation.loading"} />
    } else {
        return <Outlet />
    }
})
export default StockManagementLoader
